import { useRef } from 'react';
import styled from 'styled-components';
import { Button } from '@shared/ui/Button';
import { Dialog } from '@shared/ui/Dialog';

const Question = styled.p`
  margin: 0;
  white-space: pre-line;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export interface Export1CAsk {
  /** Повторная выгрузка уже выгружавшихся — опасный вариант: фокус на «Отмена». */
  reexport: boolean;
  text: string;
}

interface Props {
  ask: Export1CAsk | null;
  busy: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * Вопрос перед выгрузкой в 1С: что именно уйдёт в файл (количество и сумма) — до того,
 * как сервер сформирует файл и отметит заявки выгруженными. Отмена ничего не меняет.
 */
export function Export1CConfirmDialog({ ask, busy, onCancel, onConfirm }: Props) {
  const cancelRef = useRef<HTMLButtonElement>(null);
  if (!ask) return null;
  return (
    <Dialog
      open
      role="alertdialog"
      title={ask.reexport ? 'Повторная выгрузка в 1С' : 'Выгрузка в 1С'}
      initialFocusRef={ask.reexport ? cancelRef : undefined}
      onClose={() => {
        if (!busy) onCancel();
      }}
      footer={
        <>
          <Button
            ref={cancelRef}
            type="button"
            $variant="secondary"
            onClick={onCancel}
            disabled={busy}
          >
            Отмена
          </Button>
          <Button
            type="button"
            $variant={ask.reexport ? 'danger' : 'primary'}
            onClick={onConfirm}
            disabled={busy}
          >
            {busy ? 'Выгрузка…' : ask.reexport ? 'Выгрузить повторно' : 'Выгрузить'}
          </Button>
        </>
      }
    >
      <Question>{ask.text}</Question>
    </Dialog>
  );
}
